import { AnchorItem, useAnchorHookFactory } from '../../../../hooks/useAnchorHookFactory/useAnchorHookFactory';

export const useCareNoteAnchors = (anchorItems: AnchorItem) => {
  const factory = useAnchorHookFactory(anchorItems);
  return factory;
};

export const useCareNoteAnchorIdHelper = (month: string, year: number) => `${month} ${year}`;
